<template>
    <div class="my-auto content_center">
        <img class="d-flex justify-center mx-auto" src="/Done.png"/>
        <div class="d-flex justify-center mt-2 font-set">Order Confirmed</div>
        <div v-if="orderId" class="mt-2">
            <div class="d-flex justify-center mt-1 order-font-set" :style="'font-size:medium;'">Order ID: {{ orderId }}</div>
        </div>
        <div class="d-flex justify-center message-font-size mt-2">Your order is placed successfully. We have sent you the Order detail on your registered Email ID.</div>
        <div class="d-flex justify-center message-font-size mt-2">You can also check in Stock (Online) and Purchase order (Online).</div>
        <div class="d-flex justify-center mt-3" >
            <q-btn class="pd-btn" @click="openProductPage" >CONTINUE SHOPPING</q-btn>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            orderId:this.$route.query.orderId
        }
    },
    methods: {
        openProductPage() {
            this.$router.push(`/Partners/Stock/Products`)
        }
    }
}
</script>

<style>
.font-set{
    font-weight: 900;
    font-size: x-large;
    color: black;
  
}

.order-font-set{
    font-weight: 900;
    color: black;
  
}

.content_center{
    position: absolute;
    top: 48%;
    left: 48%;
    transform: translate(-48%, -50%);
    padding-bottom: 0 !important;
    
}

.message-font-size{
    font-size: medium;
}

.color-set{
    background-color: #167E85;
    color: aliceblue
}



</style>